export const RFQ_CREDIT_TYPE_OPTIONS = [
  'No Credit',
  'Cash',
  'Bank Transfer',
  'Electronic Transfer',
  'Open Credit',
  'Credit Account',
  'Letter of Credit (LC)',
] as const;

export const RFQ_PAYMENT_TERM_OPTIONS = [
  '100% Advance',
  '50% Advance + 50% Before Delivery',
  'Net 30 Days',
  'Net 45 Days',
  'Net 60 Days',
  'Net 90 Days',
  'Letter of Credit (LC)',
] as const;

/** Select sentinel — never persisted as the payment term value itself. */
export const RFQ_PAYMENT_TERM_CUSTOM_VALUE = '__custom__';

export function isPresetRfqPaymentTerm(term: string | null | undefined): boolean {
  if (!term) return false;
  return (RFQ_PAYMENT_TERM_OPTIONS as readonly string[]).includes(term);
}

/** Select value for payment term UI (preset | custom sentinel | empty). */
export function paymentTermSelectValue(term: string | null | undefined): string {
  if (!term) return '';
  return isPresetRfqPaymentTerm(term) ? term : RFQ_PAYMENT_TERM_CUSTOM_VALUE;
}

export const RFQ_INSURANCE_TERM_OPTIONS = [
  "Seller's Responsibility",
  "Buyer's Responsibility",
  'Shared Responsibility',
  'Marine Cargo Insurance',
  'All Risk Insurance',
  'Not Applicable',
] as const;

export const RFQ_TAX_TERM_OPTIONS = [
  'Tax Included',
  'Tax Excluded',
  'GST Included',
  'GST Extra',
  'VAT Included',
  'VAT Extra',
  'Duty Included',
  'Duty Extra',
  'Tax Exempt',
] as const;

export const RFQ_TRANSPORT_TERM_OPTIONS = [
  'Sea Freight',
  'Air Freight',
  'Road Transport',
  'Courier',
  'Multimodal',
  'Customer Pickup',
  'Seller Arranged',
  'Buyer Arranged',
] as const;

export const RFQ_DELIVERY_TERM_OPTIONS = [
  'Ex-Stock',
  'Immediate',
  '1–3 Days',
  '3–7 Days',
  '7–14 Days',
  '14–30 Days',
  '30–45 Days',
  '45–60 Days',
  'On Request',
  'To Be Confirmed',
] as const;

export const RFQ_PACKING_TERM_OPTIONS = [
  'Standard Packing',
  'Export Packing',
  'Seaworthy Packing',
  'Marine Packing',
  'Wooden Case',
  'Pallet',
  'Carton',
  'Buyer-Specified',
] as const;

export const RFQ_TERMS_FIELDS = [
  { key: 'creditType', label: 'Credit Type', options: RFQ_CREDIT_TYPE_OPTIONS },
  { key: 'paymentTerm', label: 'Payment Term', options: RFQ_PAYMENT_TERM_OPTIONS },
  { key: 'insuranceTerm', label: 'Insurance Term', options: RFQ_INSURANCE_TERM_OPTIONS },
  { key: 'taxTerm', label: 'Tax Term', options: RFQ_TAX_TERM_OPTIONS },
  { key: 'transportTerm', label: 'Transport Term', options: RFQ_TRANSPORT_TERM_OPTIONS },
  { key: 'deliveryTerm', label: 'Delivery Term', options: RFQ_DELIVERY_TERM_OPTIONS },
  { key: 'packingTerm', label: 'Packing Term', options: RFQ_PACKING_TERM_OPTIONS },
] as const;

export type RfqTermsFieldKey = (typeof RFQ_TERMS_FIELDS)[number]['key'];

export const RFQ_TERMS_INITIAL = Object.fromEntries(
  RFQ_TERMS_FIELDS.map(({ key }) => [key, ''])
) as Record<RfqTermsFieldKey, string>;
